import Footer from 'components/Footer'
import Header from 'components/Header'
import * as React from 'react'
import { Button } from 'react-bootstrap'

const HEADER_TITLE = '無効なURL' as const
const URL_INVALID_MESSAGE = 'この招待URLは無効です。' as const
const URL_RETRY_GUIDANCE = 'QRコードを再度読み取り直すか、ご案内のURLに誤りがないかご確認のうえ、もう一度アクセスしてください。' as const
const CONTACT_US_PATH = '/contactUs' as const
const CONTACT_US_LABEL = 'お問い合わせ' as const

/**
 * 招待URL無効案内画面 (2026-06-11 本番不具合対応)。
 *
 * QR inspect (`POST /campaign/qr/inspect`) が `campaignQrInvalid`（hash 復号不可 =
 * URL 破損・印刷物からの転記ミス等）を返した invite QR の着地先。
 * SignUpIntroduction.tsx から遷移し、壊れた hash のまま登録フォームへ
 * 進ませないための行き止まり画面（CampaignQrExpired.tsx と同構成）。
 */
const SceneComponent: React.FC = () => {
  return (
    <>
      <Header title={HEADER_TITLE} />
      <main>
        <section className="mx-4 my-5">
          <div className="mt-5">
            <p>{URL_INVALID_MESSAGE}</p>
            <p>{URL_RETRY_GUIDANCE}</p>
          </div>
          <div className="mt-4">
            <Button variant="success" className="w-100 py-4" href={CONTACT_US_PATH}>
              {CONTACT_US_LABEL}
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
